"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";
  return (
    (_typeof =
      "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj &&
              "function" == typeof Symbol &&
              obj.constructor === Symbol &&
              obj !== Symbol.prototype
              ? "symbol"
              : typeof obj;
          }),
    _typeof(obj)
  );
}

Object.defineProperty(exports, "__esModule", {
  value: true,
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactBootstrap = require("react-bootstrap");

var _reactRouterBootstrap = require("react-router-bootstrap");

var _reactRouterHashLink = require("react-router-hash-link");

var _reactResponsive = require("react-responsive");

require("../Styles/Header.styles.scss");

var _reactBootstrapIcons = require("react-bootstrap-icons");

var _Searchbar = _interopRequireDefault(
  require("../../../marketing-site/src/Pages/Searchbar")
);

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(
    nodeInterop
  ) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (
    obj === null ||
    (_typeof(obj) !== "object" && typeof obj !== "function")
  ) {
    return { default: obj };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor =
    Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor
        ? Object.getOwnPropertyDescriptor(obj, key)
        : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) ||
    _iterableToArrayLimit(arr, i) ||
    _unsupportedIterableToArray(arr, i) ||
    _nonIterableRest()
  );
}

function _nonIterableRest() {
  throw new TypeError(
    "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
  );
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i =
    arr == null
      ? null
      : (typeof Symbol !== "undefined" && arr[Symbol.iterator]) ||
        arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var Header = function Header() {
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showHeader = _useState2[0],
    setShowHeader = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isMobileMenuOpen = _useState4[0],
    setIsMobileMenuOpen = _useState4[1];

  var location = (0, _reactRouterDom.useLocation)();

  var _useState5 = (0, _react.useState)(""),
    _useState6 = _slicedToArray(_useState5, 2),
    searchkey = _useState6[0],
    setSearchKey = _useState6[1];

  var isMobile = (0, _reactResponsive.useMediaQuery)({
    query: "(max-width: 768px)",
  });
  var dummySuggestions = [
    {
      name: "hello",
      title: "Trending Search",
    },
    {
      name: "hello",
      title: "Trending Search",
    },
    {
      name: "hello",
      title: "Trending Search",
    },
    {
      name: "hello",
      title: "Trending Search",
    },
  ];

  var changeNavbarStatus = function changeNavbarStatus() {
    if (location.pathname === "/" || location.pathname === "/assets") {
      var homepageThreshold = isMobile ? 520 : 640;
      var scrollThreshold = location.pathname === "/" ? homepageThreshold : 80;
      window.scrollY >= scrollThreshold
        ? setShowHeader(true)
        : setShowHeader(false);
    } else {
      setShowHeader(true);
    }
  };

  (0, _react.useEffect)(
    function () {
      if (location.pathname !== "/" && location.pathname !== "/assets") {
        changeNavbarStatus();
      }
    },
    [location]
  );
  (0, _react.useEffect)(
    function () {
      setIsMobileMenuOpen(false);
    },
    [isMobile]
  );

  var toggleMobileMenuOpen = function toggleMobileMenuOpen() {
    if (isMobile) {
      setIsMobileMenuOpen(!isMobileMenuOpen);
    }
  };

  var scrollToTop = function scrollToTop() {
    document.documentElement.scrollTo(0, 0);
    setShowHeader(false);
  };

  (0, _react.useEffect)(
    function () {
      window.addEventListener("scroll", changeNavbarStatus, true);
      document.body.addEventListener("touchmove", changeNavbarStatus, false);
      return function () {
        window.removeEventListener("scroll", changeNavbarStatus, true);
        document.body.removeEventListener(
          "touchmove",
          changeNavbarStatus,
          false
        );
      };
    },
    [showHeader]
  );

  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    searchDataList = _useState8[0],
    setSearchDataList = _useState8[1]; // console.log("searchDataList===", searchDataList);

  var pageSize = 50;

  var _useState9 = (0, _react.useState)(0),
    _useState10 = _slicedToArray(_useState9, 2),
    pageNumber = _useState10[0],
    setPageNumber = _useState10[1];

  var allAssetDataHandler = /*#__PURE__*/ (function () {
    var _ref = _asyncToGenerator(
      /*#__PURE__*/ regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch ((_context.prev = _context.next)) {
              case 0:
                console.log("allAssetDataHandler: ");

                try {
                  _axios.default
                    .get(
                      "".concat(
                        process.env.REACT_APP_ENDPOINT,
                        "/assets/all?pageSize=10"
                      ),
                      {
                        params: {
                          pageSize: pageSize,
                          pageIdx: pageSize * pageNumber,
                        },
                      }
                    )
                    .then(function (res) {
                      setSearchDataList(res.data);
                    })
                    .catch(function (e) {
                      console.log("Error fetching featured assets", e);
                    });
                } catch (error) {
                  console.log(error);
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })
    );

    return function allAssetDataHandler() {
      return _ref.apply(this, arguments);
    };
  })();

  (0, _react.useEffect)(function () {
    allAssetDataHandler();
  }, []);
  return /*#__PURE__*/ _react.default.createElement(
    _reactBootstrap.Navbar,
    {
      expand: "md",
      expanded: isMobileMenuOpen,
      collapseOnSelect: true,
      fixed: "top",
      className: "headerWrapper "
        .concat(showHeader ? "scrollbarBGColor" : "hideHeader", " ")
        .concat(isMobileMenuOpen ? "fullMenuOpacity" : ""),
    },
    /*#__PURE__*/ _react.default.createElement(
      _reactBootstrap.Navbar.Brand,
      {
        className: "headerLogoWrapper",
        onClick: function onClick() {
          scrollToTop();
        },
      },
      /*#__PURE__*/ _react.default.createElement(
        _reactRouterBootstrap.LinkContainer,
        {
          activeClassName: "activeHeaderMenu",
          to: "/",
        },
        /*#__PURE__*/ _react.default.createElement(
          _reactBootstrap.Nav.Link,
          null,
          /*#__PURE__*/ _react.default.createElement("img", {
            src: isMobile
              ? "https://d241vrp4b4n7qa.cloudfront.net/Assets/logo_icon.svg"
              : "https://d241vrp4b4n7qa.cloudfront.net/Assets/logo_horiz.png",
            alt: "Logo",
          })
        )
      )
    ),
    /*#__PURE__*/ _react.default.createElement(
      _reactBootstrap.Navbar.Toggle,
      {
        onClick: function onClick() {
          return toggleMobileMenuOpen();
        },
      },
      /*#__PURE__*/ _react.default.createElement(
        "div",
        {
          className: "mobile-menu ".concat(isMobileMenuOpen ? "open" : ""),
        },
        /*#__PURE__*/ _react.default.createElement("div", {
          className: "bar-one",
        }),
        /*#__PURE__*/ _react.default.createElement("div", {
          className: "bar-two",
        }),
        /*#__PURE__*/ _react.default.createElement("div", {
          className: "bar-three",
        })
      )
    ),
    /*#__PURE__*/ _react.default.createElement(
      _reactBootstrap.Navbar.Collapse,
      {
        expand: "lg",
        className: "headerMenu ".concat(isMobile ? "mobileDropdown" : ""),
      },
      /*#__PURE__*/ _react.default.createElement(
        _reactBootstrap.Nav,
        null,
        /*#__PURE__*/ _react.default.createElement(
          "div",
          {
            className: "searchBoxHeader",
          },
          /*#__PURE__*/ _react.default.createElement(
            "div",
            {
              className: "searchBoxParent",
            },
            /*#__PURE__*/ _react.default.createElement(
              _reactBootstrapIcons.Search,
              null
            ),
            "\xA0\xA0",
            /*#__PURE__*/ _react.default.createElement("input", {
              type: "search",
              className: "inputSearchField",
              onChange: function onChange(e) {
                return setSearchKey(e.target.value);
              },
            }),
            /*#__PURE__*/ _react.default.createElement(
              "button",
              {
                className: "btnSearch",
              },
              "Search"
            )
          ),
          /*#__PURE__*/ _react.default.createElement(
            "div",
            {
              className: "searchBoxChild",
              id: "serch",
            },
            /*#__PURE__*/ _react.default.createElement("div", {
              className: "searchBoxContent",
            }),
            searchkey !== "" &&
              /*#__PURE__*/ _react.default.createElement(
                _react.default.Fragment,
                null,
                searchDataList &&
                  searchDataList.map(function (data, i) {
                    return /*#__PURE__*/ _react.default.createElement(
                      _Searchbar.default,
                      {
                        data: data,
                        index: i,
                      }
                    );
                  })
              )
          )
        ),
        /*#__PURE__*/ _react.default.createElement(
          _reactBootstrap.Nav.Item,
          {
            onClick: function onClick() {
              return toggleMobileMenuOpen();
            },
          },
          /*#__PURE__*/ _react.default.createElement(
            _reactRouterBootstrap.LinkContainer,
            {
              className: "navLink",
              to: "/Assets",
            },
            /*#__PURE__*/ _react.default.createElement(
              _reactBootstrap.Nav.Link,
              null,
              "Assets"
            )
          )
        ),
        /*#__PURE__*/ _react.default.createElement(
          _reactBootstrap.Nav.Item,
          {
            onClick: function onClick() {
              return toggleMobileMenuOpen();
            },
          },
          /*#__PURE__*/ _react.default.createElement(
            _reactRouterHashLink.NavHashLink,
            {
              className: "activeHeaderMenu",
              to: "/#faq-sec",
            },
            "FAQ"
          )
        )
      )
    )
  );
};

var _default = Header;
/*
<<<<<<< HEAD
=======
<<<<<<< HEAD
>>>>>>> main
 <Nav.Item>
            <LinkContainer activeClassName='activeHeaderMenu' to='/'>
              <Nav.Link>Redeem</Nav.Link>
            </LinkContainer>
          </Nav.Item>
<<<<<<< HEAD
=======
=======
  <Navbar.Toggle><List /></Navbar.Toggle>
  <Navbar.Collapse  expand="lg" className="headerMenu">
    <Nav>
      <Nav.Item>
        <LinkContainer activeClassName="activeHeaderMenu" to="/Assets">
          <Nav.Link>Assets</Nav.Link>
        </LinkContainer>
      </Nav.Item>
      <Nav.Item>
        <NavHashLink to="/#faq-sec">FAQ</NavHashLink>
      </Nav.Item>
      <Nav.Item>
        <LinkContainer activeClassName="activeHeaderMenu" to="/">
          <Nav.Link>Redeem</Nav.Link>
        </LinkContainer>
      </Nav.Item>
    </Nav>
  </Navbar.Collapse>
>>>>>>> main
>>>>>>> main
*/

exports["default"] = _default;
